import { useEffect, useState } from 'react';
import { Crown } from 'lucide-react';
import { api } from '@/lib/api';

const PLAN_COLORS = {
    basic: 'bg-slate-100 text-slate-700 border-slate-300',
    pro: 'bg-amber-50 text-amber-700 border-amber-300',
    premium: 'bg-rose-50 text-rose-700 border-rose-300',
};

export const ProBadge = ({ userId, plan: planProp = null, className = '', size = 'sm' }) => {
    const [plan, setPlan] = useState(planProp);
    const [label, setLabel] = useState(null);

    useEffect(() => {
        if (planProp) return;
        if (!userId) return;
        let cancelled = false;
        (async () => {
            try {
                const { data } = await api.get(`/pro/badge/${userId}`);
                if (!cancelled && data.active) { setPlan(data.plan); setLabel(data.badge); }
            } catch (_) {}
        })();
        return () => { cancelled = true; };
    }, [userId, planProp]);

    if (!plan) return null;
    const cls = PLAN_COLORS[plan] || PLAN_COLORS.pro;
    const displayLabel = label || (plan === 'premium' ? 'OK Premium' : plan === 'pro' ? 'OK Pro' : 'OK Básico');
    const pad = size === 'lg' ? 'text-xs px-2 py-1' : 'text-[10px] px-1.5 py-0.5';
    return (
        <span className={`inline-flex items-center gap-1 rounded-full border ${cls} ${pad} font-semibold uppercase tracking-wide ${className}`} data-testid={`pro-badge-${plan}`}>
            <Crown className={size === 'lg' ? 'h-3 w-3' : 'h-2.5 w-2.5'} />{displayLabel}
        </span>
    );
};
